/**
 * 经典橙色模板 - 首页
 * 
 * 布局：标准两栏布局，顶部搜索 + 分类展示 + 最新信息
 */

import { useEffect, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import LatestListings from "./components/LatestListings";
import { getSiteInfo } from "@/utils/api";

export default function HomePage() {
  const [searchConfig, setSearchConfig] = useState({
    enabled: true,
    disabledMessage: "搜索功能已关闭",
  });

  useEffect(() => {
    // 设置 SEO 信息
    getSiteInfo().then((info) => {
      if (info) {
        document.title = info.seo_title || '';
        
        // 设置 meta description
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc && info.seo_description) {
          metaDesc.setAttribute("content", info.seo_description);
        } else if (info.seo_description) {
          const meta = document.createElement("meta");
          meta.name = "description";
          meta.content = info.seo_description;
          document.head.appendChild(meta);
        }
        
        // 设置搜索配置
        if (info.search_enabled !== undefined || info.search_disabled_message) {
          setSearchConfig({
            enabled: info.search_enabled !== false,
            disabledMessage: info.search_disabled_message || "搜索功能已关闭",
          });
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <Navbar />
      <main>
        <HeroSection searchConfig={searchConfig} />
        <CategorySection />
        <LatestListings />
      </main>
      <Footer />
    </div>
  );
}
